var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-overlay',{attrs:{"value":_vm.value,"z-index":"1000"}},[_c('v-alert',[_c('v-icon',{attrs:{"x-large":""}},[_vm._v("mdi-email-fast-outline")]),_c('v-progress-linear',{attrs:{"indeterminate":"","color":"cyan"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }